export const PAYMENT_METHOD = {
  STC: 'stc',
  STC_BANK: 'stc_bank',
  TAP: 'tap',
  TAP_CARD: 'tap_card',
  TAP_APPLEPAY: 'tap_applepay',
  TAP_GOOGLEPAY: 'tap_googlepay',
};

/**
 * Tap authorize auto-VOID schedule (hours). 168 hours = 7 days, and that is
 * Tap's documented ceiling: "In hours. Minimum: 1 Maximum: 168 (Visa and
 * MasterCard tokens is up to 720 hours)"
 * (https://developers.tap.company/reference/create-an-authorize). The 720h
 * extension is unusable here -- we authorize before knowing the card scheme,
 * so a mada card would be sent a value it can't honour. The hold therefore
 * cannot be lengthened; the booking window is what has to fit inside it.
 * server/api-util/paymentWindowEnforcement.js duplicates these values
 * server-side -- keep both in sync if they change.
 */
export const TAP_AUTHORIZE_AUTO_VOID_HOURS = {
  MADA: 168,
};

/**
 * How long after a job ends a merchant may still redeem it and have the
 * capture succeed. This is the ONE knob: BOOKING_WINDOW_HOURS,
 * MAX_ADVANCE_BOOKING_DAYS and the transaction process's
 * transition/auto-cancel period (booking-end + this, see
 * ext/transaction-processes/default-booking/process.edn) are all derived from
 * it, and they are only coherent while they all come from this value. At the
 * old settings they did not: the process promised a 7-day redemption window
 * on a 7-day hold, which leaves zero bookable range.
 */
export const REDEMPTION_ALLOWANCE_HOURS = 12;

/**
 * The real booking cutoff: a booking's END (capture only happens at
 * redemption, after the service -- see server/api/payment/verify-payout.js)
 * plus the redemption allowance has to fit inside the hold.
 */
export const BOOKING_WINDOW_HOURS = TAP_AUTHORIZE_AUTO_VOID_HOURS.MADA - REDEMPTION_ALLOWANCE_HOURS;

/**
 * The same window as whole days, for calendar cutoffs and customer-facing
 * copy -- NOT the guard. A day-granular calendar bounded by this alone would
 * still offer late slots on the final day that BOOKING_WINDOW_HOURS rejects,
 * which is why the time pickers filter by the hour-precise ceiling too.
 */
export const MAX_ADVANCE_BOOKING_DAYS = Math.floor(BOOKING_WINDOW_HOURS / 24);

/**
 * The instant a booking must END by, given when its authorization hold was
 * (or is about to be) created. `from` defaults to now, which is right for a
 * new booking -- the hold is minted at checkout, moments later. A reschedule
 * passes the ORIGINAL booking's creation time instead, since it moves dates
 * under a hold that already exists and is partway through its life.
 *
 * Pickers filter their time options by this, so the UI can never offer a slot
 * the server's identical check would reject at checkout. MAX_ADVANCE_BOOKING_DAYS
 * alone can't do that job: a day-granular calendar admits the whole final day.
 */
export const bookingWindowCeiling = (from = Date.now()) =>
  new Date(new Date(from).getTime() + BOOKING_WINDOW_HOURS * 60 * 60 * 1000);

export const LEDGER_ENTRY_TYPE = {
  PAYIN: 'payin',
  PAYIN_PENDING: 'payin_pending',
  PAYIN_AVAILABLE: 'payin_available',
  PAYIN_RELEASED: 'payin_released',

  PAYOUT: 'payout',
  PAYOUT_PROCESSING: 'payout_processing',
  PAYOUT_RESERVED: 'payout_reserved',
  PAYOUT_COMPLETED: 'payout_completed',
  PAYOUT_FAILED: 'payout_failed',
};
